module.exports = __webpack_public_path__ + "static/media/lj-arrow.67d36fee.svg";